module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/intro-7c8c3dbd18f2853f8d9a4cf0fe63e4cb.svg";